module.exports = __webpack_public_path__ + "img/xrp.84ce7542.svg";